import React from "react";
import { BellOff } from "lucide-react";

/**
 * MutedPill — a table-row flag. Shows only when a partner has actually turned something off,
 * so a quiet partner is never mistaken for a cold one.
 */
export const MutedPill = ({ summary, id }) => {
  if (!summary?.any) return null;
  const bits = [...(summary.channels_off || []), ...(summary.muted || [])];
  return (
    <span className="inline-flex items-center gap-1 rounded-full border border-slate-300 bg-white px-2 h-5 text-[10px] font-semibold text-slate-600"
          title={`Muted: ${bits.join(" · ")}`} data-testid={`partner-muted-pill-${id}`}>
      <BellOff className="size-2.5" /> muted {summary.count}
    </span>
  );
};

/**
 * MutedNotice — the readable version, for a partner's record. Names exactly what they've
 * switched off before you assume they're ignoring you.
 */
export const MutedNotice = ({ summary, name }) => {
  if (!summary?.any) return null;
  const channels = summary.channels_off || [];
  const cats = summary.muted || [];
  return (
    <div className="rounded-xl border border-[#7da9ff]/45 bg-[#7da9ff]/[0.10] p-3.5" data-testid="partner-muted-notice">
      <div className="flex items-center gap-2 text-[13px] font-semibold text-[#24457F]">
        <BellOff className="size-3.5" /> {name || "This partner"} has muted some of our messages
      </div>
      <div className="mt-1.5 space-y-1 text-[12px] text-[#24457F]">
        {channels.length > 0 && (
          <div><span className="text-[#3B63A8]">Channels off:</span> <b>{channels.join(", ")}</b></div>
        )}
        {cats.length > 0 && (
          <div><span className="text-[#3B63A8]">Not being told about:</span> <b>{cats.join(", ")}</b></div>
        )}
      </div>
      <div className="mt-2 text-[11.5px] text-[#2F5390]/80">
        They're not ignoring you — they've turned this off themselves. Contracts awaiting signature and
        new cases still always reach their inbox. Worth a call rather than another email.
      </div>
    </div>
  );
};
